<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{enabled: !disabled, trigger: 'click', mode: 'row'}"
      :height="disabled ? 0 : 300"
      border
      :edit-rules="validRules"
      :toolbar-config="tableToolbar"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span class="side-frame-text">包车费信息</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="add(-1)"
              v-if="!disabled && chartersBillingPlan === 'D'"
              ><i class="el-icon-plus" />添加
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              v-if="!disabled && chartersBillingPlan === 'D'"
              @click="batchDel()"
              ><i class="el-icon-delete" />删除
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{row}">
        <el-tooltip
          v-allow="'actDel'"
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          v-if="chartersBillingPlan === 'D'"
        >
          <i class="el-icon-delete tool-btn" @click="del(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
    <!-- <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">保存</el-button>
    </div> -->
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    contractChartersCode: String,
    contractCode: String,
    disabled: Boolean,
    chartersBillingPlan: String,
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns({disabled: this.disabled, unitDisabled: true}),
      unitList: [
        {value: 'A', label: '总价'},
        {value: 'B', label: '天单价'},
        {value: 'C', label: '次单价'},
        {value: 'D', label: '车单价'},
      ],
      isReady: false,

      validRules: {
        minMatch: [{required: true, message: '请输入区间下限'}],
        maxMatch: [{required: true, message: '请输入区间上限'}],
        price: [{required: true, message: '请输入单位价'}],
        unit: [{required: true, message: '请选择单位'}],
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
    }
  },
  watch: {
    // 避免父组件重新渲染子组件机制警告
    tableData: {
      handler(tableData) {
        if (tableData && tableData !== [] && tableData.length > 0) {
          this.vtableData = tableData
        }
      },
      immediate: true,
    },
    chartersBillingPlan(newVal) {
      this.changeChartersBillingPlan(newVal)
      if (!this.isReady && this.contractChartersCode){
        this.getData()
        this.isReady = true
      }
    },
  },
  created() {
    this.tableColumns[6].editRender.options = this.unitList
    this.getData()
  },
  methods: {
    getData() {
      if (!this.contractChartersCode) return
      this.$api
        .contractCustomerChartersSettingListApi({
          contractChartersCode: this.contractChartersCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async add(row) {
      const $table = this.$refs.table
      let data = {}
      if (this.chartersBillingPlan === 'D'){
        data.unit = 'C'
        let tableData = $table.getTableData().tableData
        let length = tableData.length
        if (length > 0){
          let currRow = tableData[length - 1]
          data.minMatch = currRow.maxMatch
        }
      }
      const {row: newRow} = await $table.insertAt(data, row)
      await $table.setActiveCell(newRow, 'minMatch')
      await this.resetSeq()
    },
    async save() {
      const tableData = await this.getTableData()
      const validResult = await this.validEvent()
      console.log(validResult)

      if (!validResult) return Promise.reject()

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .contractCustomerChartersSettingSaveApi({
          chartersSetList: tableData,
          contractCode: this.contractCode,
        })
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    async del(row) {
      this.$refs.table.remove(row)
      this.resetSeq()
    },
    async batchDel(){
      this.$refs.table.removeCheckboxRow()
      this.resetSeq()
    },
    async resetSeq(){
      const tableData = await this.getTableData()
      tableData.forEach((item,index) => {
        this.$set(item,'seqNo',index + 1)
      })
    },
    async getTableData() {
      const $table = this.$refs.table
      return await $table.getTableData().tableData
    },
    async validEvent() {
      const $table = this.$refs.table
      const errMap = await $table.validate(true).catch((errMap) => errMap)
      if (errMap) {
        return false
      } else {
        return true
      }
    },
    changeChartersBillingPlan(newVal){
      const $table = this.$refs.table
      $table.remove()
      //设置下拉框数据
      if (newVal === 'A') {
        this.unitList = [
          {value: 'B', label: '天单价'},
          {value: 'C', label: '次单价'},
        ]
        $table.insert([{minMatch: 0, maxMatch: 0, price: 0, unit: 'B'},
          {minMatch: 0, maxMatch: 0, price: 0, unit: 'C'}])
      } else if (newVal === 'B') {
        this.unitList = [{value: 'A', label: '总价'},{value: 'C', label: '次单价'}]
        $table.insert([{minMatch: 0, maxMatch: 0, price: 0, unit: 'A'},{minMatch: 0, maxMatch: 0, price: 0, unit: 'C'}])
      } else if (newVal === 'C') {
        this.unitList = [{value: 'D', label: '车单价'}]
        $table.insert([{minMatch: 0, maxMatch: 0, price: 0, unit: 'D'}])
      }else if(newVal == 'D'){
        this.unitList = [{value: 'C', label: '次单价'}]
        $table.insert([{minMatch: 0, maxMatch: 0, price: 0, unit: 'C'}])
      }
      //是否可选中下拉框
      if (newVal === 'D'){
        this.tableColumns = tableColumns({visible: this.disabled,unitDisabled:false})
      }else{
        this.tableColumns = tableColumns({visible: this.disabled,unitDisabled:true})
      }
      this.tableColumns[6].editRender.options = this.unitList
      this.resetSeq()
    }
  },
}
</script>
